import React from 'react';
import { motion } from 'framer-motion';
import { QuoteIcon } from 'lucide-react';
import { moreResults } from '../data/testimonials';
export function MoreResults() {
  return <section className="bg-slate-900 py-16 sm:py-20" aria-labelledby="results-title" data-id="element-152" data-mp="28f80yjn3pvsp">
      <div className="mx-auto max-w-5xl px-4" data-id="element-153" data-mp="28ddg15bty3om">
        <h2 id="results-title" className="text-center text-3xl font-extrabold text-white sm:text-4xl" data-id="element-154" data-mp="2d6zu91xn6fmj">
          What educators using this teacher ready say
        </h2>
        <div className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-155" data-mp="2m6cwpancm3xr">
          {moreResults.map(([initials, name, place, quote], index) => <motion.article key={name} initial={{
          opacity: 0,
          y: 14
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.04,
          ease: [0.23, 1, 0.32, 1]
        }} className={`flex flex-col rounded-xl border border-slate-400/20 bg-slate-800 p-6 shadow-lg shadow-black/20 ${index === 4 ? 'md:col-span-2' : ''}`} data-id="element-156" data-mp="2r70woltk1v44" data-mpi={index}>
              <QuoteIcon className="h-6 w-6 text-slate-300" aria-hidden="true" data-id="element-157" data-mp="3impmvlv16p3q" />
              <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-slate-200" data-id="element-158" data-mp="3ikwhe9w5maxb">“{quote}”</blockquote>
              <div className="mt-6 flex items-center gap-3 border-t border-slate-400/15 pt-4" data-id="element-159" data-mp="38ojq1io3095q">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg metal text-sm font-extrabold text-slate-950" data-id="element-160" data-mp="38mp5i5gq2j26">
                  {initials}
                </span>
                <span data-id="element-161" data-mp="5607x8z4ajon">
                  <b className="block text-sm text-white" data-id="element-162" data-mp="8gkbigj4uk1">{name}</b>
                  <small className="text-xs text-slate-400" data-id="element-163" data-mp="at5e4hl3l1b">{place}</small>
                </span>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}